import{__require as r}from"./get-built-in.js";var e,t;function n(){if(t)return e;t=1;var n=r();return e=n("document","documentElement")}export{n as __require};
//# sourceMappingURL=html.js.map
